export default __webpack_public_path__ + "static/media/Google.d6157540.svg";